/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A swing you can repeat`)
};

const es_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un swing que puedes repetir`)
};

const de_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schwung, den Sie wiederholen können`)
};

const zh_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以重复的挥杆`)
};

const ar_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سوينغ يمكنك تكراره`)
};

const fr_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un swing que vous pouvez répéter`)
};

const vi_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing bạn có thể lặp lại`)
};

const sw_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing unayoweza kuirudia`)
};

const th_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวิงที่คุณทำซ้ำได้`)
};

const bs_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing koji možeš ponavljati`)
};

const ja_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが繰り返すことができるスイング`)
};

const ko_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스윙 당신은 반복 할 수`)
};

const pt_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um swing que você pode repetir`)
};

const it_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno swing che si può ripetere`)
};

const sv_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En sving du kan upprepa`)
};

const nl_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een swing die je kunt herhalen`)
};

const da_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et sving du kan gentage`)
};

const nb_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En sving du kan gjenta`)
};

const fi_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing, jonka voit toistaa`)
};

const pl_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing można powtórzyć`)
};

const ru_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свинг, который можно повторить`)
};

const tr_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrarlayabileceğiniz bir swing`)
};

const hi_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक स्विंग आप दोहरा सकते हैं`)
};

const id_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayunan yang bisa Anda ulangi`)
};

const ms_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayunan yang boleh anda ulangi`)
};

const cs_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Švih, který zvládnete zopakovat`)
};

const el_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μια σβινγκ που μπορείς να επαναλάβεις`)
};

const he_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סווינג שתוכלו לחזור עליו`)
};

const af_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Swaai wat jy kan herhaal`)
};

const hu_method_content_step_06_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megismételhető swing`)
};

/**
* | output |
* | --- |
* | "A swing you can repeat" |
*
* @param {Method_Content_Step_06_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_beginner_1_heading(inputs)
	return en_method_content_step_06_detail_beginner_1_heading(inputs)
});